/**
 * Initializes all cookie-settings-buttons with event handlers to open the cookie settings
 */
export default function initializeCookieSettingsOpener() {
    if (typeof window.OneTrust !== 'undefined') {
        document.querySelectorAll('.js-cookie-settings__button').forEach((button) => {
            // Add listener in case the user wants to change the cookie settings
            button.addEventListener('click', () => OneTrust.ToggleInfoDisplay())
        })
    } else {
        // This workaround was required since there seems to be no event firing, when OneTrust is available
        // Please refactor if a better way is available
        setTimeout(initializeCookieSettingsOpener, 250)
    }
}
